<template>
  <v-footer dark padless>
    <v-card flat tile style="width: 100%;">
      <v-card-text v-if="show">
        <v-container>
          <v-row>
            <v-col cols="3">
              <span class="text-h6">{{$t('footer.developer')}}</span>
              <li v-for="(link, i) in devlinks" :key="`_FOOTER-LINKS-${i}`"><a :href="link.link" target="_blank">{{link.name}}</a></li>
            </v-col>
            <v-col cols="3">
              <span class="text-h6">{{$t('footer.we')}}</span>
            </v-col>
            <v-col cols="3">
              <span class="text-h6">{{$t('footer.link')}}</span>
              <li v-for="(link, i) in links" :key="`_FOOTER-LINKS-${i}`"><a :href="link.link" target="_blank">{{link.name}}</a></li>
            </v-col>
            <v-col cols="2">
              <span class="text-h6">TODO.</span><br/>
              <span>This's a feature,not a bug.</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="white--text text-center">
        {{$t('footer.tra')}}<br />
        <i18n path="footer.copy">
          <span place="year">2015 - {{ new Date().getFullYear() }}</span>
          <strong place="strong">{{$t('footer.co')}}</strong>
          <a v-if="$store.state.OPTIONS._local_lang.type === 'zh'" place="miit" href="http://beian.miit.gov.cn/" target="_blank">{{$t('footer.beian')}}</a>
        </i18n>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  data() {
    return {
      links: this.$store.state.OPTIONS._app_links ? this.$store.state.OPTIONS._app_links : [{name: 'GiriGiri Eye',link: 'https://girigiri.makjust.com'},],
      devlinks: this.$store.state.OPTIONS._app_devlinks 
    };
  },
  methods: {
    getMeal() {}
  },
  props:{
    show: Boolean
  }
};
</script>
